const fieldName = {
  NAME: 'name',
  DESCRIPTION: 'description',
  SET: 'set',
};

export default fieldName;
